class Workspace {
    //TODO: complete conversion to class design - especially move some functions out of constructor
    constructor(selector, uri) {

        const W = window.innerWidth;
        const H = window.innerHeight;
        const W_SPACE = W * 0.4;
        const H_SPACE = H * 0.4;
        const DATE_FORMAT = d3.time.format("%Y/%m/%d");

        let workspace = d3.select(selector);
        let d3divWorkspaceLower = workspace.append("div").attr("id", "workspace-lower");
        let d3svgOverlay = workspace.append("svg").attr("id", "overlay");
        let d3divWorkspaceUpper = workspace.append("div").attr("id", "workspace-upper");
        let d3divMetaspaces = workspace.append("div").attr("id", "metaspaces");
        let idSpace = 0;
        let model = {
            spaces: []
        };

        let componentSearch = searcher.searcher();
        let idSearcher = 0;
        let searchers = [];

        // jQuery.fx.interval = 1;

        let query = new Query(uri);

        // Get the data
        //TODO: let this handle very large amounts of data, by getting aggregated data at first,
        // and only getting details when spaces are created.
        query.promiseSpaceNodeData()
            .then(
                result => {
                    console.log("Resolved node overview data.");
                    model.nodes = result;
                    return Promise.all(result.map(d => query.promiseSpaceAttributeData(d.name)));
                },
                error => console.log("ERROR: Rejected node overview data: " + error)
            )
            .then(
                results => {
                    console.log("Resolved attribute data.");
                    for (let i in results) model.nodes[i].attributes = results[i];

                    // Get hierarchy data if needed
                    let hierarchyAttributes = _(results).flatten(true).filter(d => d.type === "hierarchy");
                    return Promise.all(hierarchyAttributes.map(d => query.promiseHierarchyData(d.name)));
                },
                error => console.log("ERROR: Rejected attribute data: " + error)
            )
            .then(
                results => {
                    console.log("Resolved hierarchy data.");
                    model.hierarchies = {};
                    for (let d of results) model.hierarchies[d.name] = d.hierarchy;
                    return Promise.all(model.nodes.map(d => query.promisePointData(d.name, d.attributes)))
                },
                error => console.log("ERROR: Rejected hierarchy data: " + error)
            )
            .then(
                results => {
                    console.log("Resolved point data.");
                    for (let i in results) {
                        let node = model.nodes[i];
                        node.points = results[i];
                        let cf = crossfilter(node.points);      //TODO: seems overkill to use crossfilter here
                        for (let i in node.attributes) {
                            let dim = cf.dimension(d => d[i]);
                            // Apply any needed data conversions, e.g. hierarchy to layout positions
                            //TODO: conversion should be in query.js
                            let a = node.attributes[i];
                            switch (a.type) {
                                case "hierarchy":
                                    let h = model.hierarchies[a.name];
                                    // Create a d3 partition layout to track position of elements
                                    h.d3partition = d3.layout.partition()
                                        .value((d) => {
                                            if (d.children && d.children.length > 0) {
                                                return reduce((a, b) => a + b.value(), 0);
                                            }
                                            else {
                                                return 1;		//TODO: weight using the size axis
                                            }
                                        })
                                        .sort((a, b) => b.name - a.name)
                                    ;
                                    // Change the value from Neo4jId to match the actual partition structure's x position.
                                    // Note that this is done to form a linear relationship between the data points
                                    // and displayed position, so brushes can properly scale between domain and range.
                                    let leaves = h.d3partition.nodes(h.root).filter(d => d.hasOwnProperty("hierarchy_id"));
                                    let all = dim.top(Infinity);
                                    for (let d of all) {
                                        let id = d[i];
                                        let newValue = 0;
                                        for (let leaf of leaves) {
                                            if (leaf.hierarchy_id === id) {
                                                newValue = leaf.x;
                                                break;
                                            }
                                        }
                                        d[i] = newValue;
                                    }
                                    break;
                                case "date":
                                    for (let point of node.points) {
                                        point[i] = DATE_FORMAT.parse(point[i]);
                                    }
                            }

                            // Fix attributes to reference the related node
                            a.node = model.nodes.find(d => d.name === a.node);

                            dim.dispose();
                        }

                        // In case data was altered, rebuild the crossfilter before finding extents.
                        cf = crossfilter(node.points);
                        for (let i in node.attributes) {
                            // Set up extents for each attribute, used later to create scales
                            let dim = cf.dimension(d => d[i]);
                            node.attributes[i].extent = [dim.bottom(1)[0][i], dim.top(1)[0][i]];
                            dim.dispose();
                        }
                    }
                    return Promise.all(model.nodes.map(d => query.promiseRelationshipData(d.name, d.paths)));
                },
                error => console.log("ERROR: Rejected point data: " + error)
            )
            .then(
                results => {
                    console.log("Resolved relationship data.");
                    // Rework result into something faster to look up later. I.e. convert [{nameNode: {idThere: [idHere, ...]}, ...}, ...]
                    // into model.node.relationships = [i Node to][[ref Point there, [ref Point here, ref Point here, ...]], ...]
                    for (let i in results) {
                        let nodeHere = model.nodes[i];
                        nodeHere.relationships = {};

                        for (let nameThere of Object.keys(results[i])) {
                            nodeHere.relationships[nameThere] = [];
                            let nodeThere = model.nodes.find(d => d.name === nameThere);

                            let rSource = results[i][nameThere];
                            for (let [idThere, idsHere] of rSource) {
                                let pointThere = nodeThere.points.find(d => d[0] === idThere);
                                let pointsHere = idsHere.map(id => nodeHere.points.find(d => d[0] === id));
                                nodeHere.relationships[nameThere].push([pointThere, pointsHere]);
                            }
                        }
                    }

                    // Got everything, make interactive elements available
                    // Create buttons. TODO: use proper meta graph representation
                    d3divMetaspaces
                        .append("button")
                        .classed("search", true)
                        .text("Search")
                        .on("click", onsearch)
                    ;
                    // Create meta nodes
                    d3divMetaspaces.selectAll("div.space").data(model.nodes).enter()
                        .append("div").classed("metanode", true)
                        .each(function(d, i) {
                            let node = new MetaNode();
                            node
                                .div(this)
                                .viewport(d3divMetaspaces.node())
                                .node(d)
                                .onPlot((extents) => {
                                    onspawn(d, extents, null, [Math.random() * (W - W_SPACE), Math.random() * (H - H_SPACE)])
                                })
                                .onMove(() => onrefresh(false, false, true))
                                .make()
                            ;
                            // Offset a bit for presentation.
                            $(this).css({
                                top: (H / model.nodes.length * i),
                                left: (W / 20 * (i % 2))
                            });


                        })
                    ;
                    onrefresh(false, false, true);
                },
                error => console.log("ERROR: Rejected relationship data: " + error)
            )
            //.catch(
            //    error => console.log(["CAUGHT: ", error])
            //)
        ;


        draw();

        function draw() {
            //let throttledRefresh = _.throttle(onrefresh, 67);		// ~15fps
            let throttledRefresh = onrefresh;		// Unrestricted

            for (let space of model.spaces) {
                var s = aspace.space();
                if (!space.d3div) {
                    s
                        .modelNodes(model.nodes)
                        .modelSpace(space)
                        .modelHierarchies(model.hierarchies)

                        .onload(onload)
                        .onspawn(onspawn)
                        .onexit(onexit)
                        .onrefresh(throttledRefresh)
                        .onmove(throttledRefresh)
                        .viewport(d3divWorkspaceLower.node())
                    ;
                    d3divWorkspaceLower.append("div").call(s);
                }
            }

            throttledRefresh();
        }


        function onload() {}

        function onspawn(node, extents, ids, pos) {
            // Can filter by both extents and ids, ignoring either if not given - note that [] still filters
            let space = {
                id: "demo_" + (idSpace++),
                node,
                hubs: {},
                extents,
                ids
            };
            model.spaces.push(space);
            draw();
            componentSearch.addSpace(space);
        }


        function onexit(id) {
            for (let space of model.spaces) {
                if (space.id === id) {
                    space.d3div.remove();
                }
            }
            model.spaces = model.spaces.filter(d => d.id !== id);
            draw();
        }


        function onsearch() {
            searchers.push({
                id: idSearcher++,
                result: NaN
            });

            componentSearch
                .viewport(d3divWorkspaceUpper.node())
                .onmove(onrefresh)
                .onupdate(d => {
                    // Tell all open spaces to make a special selection on given ID
                    for (let space of model.spaces) {
                        space.callbacks.selectById(d.result);
                    }

                    onrefresh();
                })
                .onexit( dSearcher => {
                    // Undo selections for this searcher
                    for (let space of model.spaces) {
                        space.callbacks.unselectById(dSearcher.result);
                    }
                    // Remove the searcher data
                    searchers = _(searchers).reject(d => d.id === dSearcher.id);
                    onrefresh();
                })
            ;
            for (let space of model.spaces) {
                componentSearch.addSpace(space);
            }

            let d3gSearcher = d3divWorkspaceUpper.selectAll("div.searcher").data(searchers, d => d.id);
            d3gSearcher.enter()
                .append("div")
                .attr("class", d => "searcher " + d.id)
                .call(componentSearch)
            ;
        }


        function onrefresh(doSpaces = true, doSearchers = true, doMeta = true) {
            if (doSearchers || doSpaces) {
                // Update edges for the searchers - these will change whenever plots change as well
                let d3gSearcher = d3svgOverlay.selectAll("g.searcher").data(searchers, d => d.id);
                d3gSearcher.enter()
                    .append("g")
                    .attr("class", d => "searcher " + d.id)
                ;
                d3gSearcher.each(function (dSearcher) {
                    let origin = $("div.searcher." + dSearcher.id).offset();

                    let targets = [];
                    let i = model.spaces.length;
                    while (i--) {
                        let space = model.spaces[i];
                        let offset = $(space.layout.d3svgChart.node()).offset();
                        let point = _(space.points).find(d => d.data[0] === dSearcher.result);

                        if (point) targets.push({
                            idNode: point.data[0],
                            idSpace: space.id,
                            pos: [offset.left + point.x, offset.top + point.y]
                        });
                    }

                    let d3line = d3.select(this).selectAll("line")
                            .data(targets, d => d.idSpace)
                        ;
                    d3line.enter().append("line");
                    d3line
                        .attr("x1", d => origin.left)
                        .attr("y1", d => origin.top)
                        .attr("x2", d => d.pos[0])
                        .attr("y2", d => d.pos[1])
                    ;
                    d3line.exit().remove();
                });
                d3gSearcher.exit().remove();
            }

            if (doSpaces) {
                // Get info on all hubs and associated points, then draw bundled
                // edges between them
                let bundles = [];
                let i = model.spaces.length;
                while (i--) {
                    let space = model.spaces[i];
                    let offsetSpace = $(space.layout.d3svgChart.node()).offset();
                    let hubs = space.hubs;

                    for (let type in hubs) {        //TODO: converting hubs to array will be faster for colour, or, put colour directly on points
                        let j = hubs[type].length;
                        let colour = _(model.nodes).findWhere({name: type}).colour;

                        while (j--) {
                            let hub = hubs[type][j];
                            let drawTo = space.options.edges[type].to;
                            let bundle = {
                                spaceId: space.id,
                                hubId: hub.hubId,
                                colour: colour,
                                posHub: [offsetSpace.left + hub.x, offsetSpace.top + hub.y],
                                posRelated: hub.d3gRelatedPoints.data().map(d => [offsetSpace.left + d.x, offsetSpace.top + d.y])
                            };
                            // Draw to the selected destination
                            // drawTo values are 0: none, 1: selection, 2: all
                            if (drawTo) {
                                bundle.posRoots = model.spaces.reduce((accum, space) => {
                                    if (space.node.name !== type) return accum;
                                    let points = (drawTo > 1) ? space.points : (space.active && space.active.dims[0].top(Infinity) || []);
                                    let point = _(points).find(d => d.data[0] == hub.hubId);  //TODO: Investigate why this id is sometimes a string
                                    if (point) {
                                        let offset = $(space.layout.d3svgChart.node()).offset();
                                        accum.push([offset.left + point.x, offset.top + point.y]);
                                    }
                                    return accum;
                                }, []);
                            }
                            else bundle.posRoots = [];
                            bundles.push(bundle);
                        }
                    }
                }
                let d3gBundle = d3svgOverlay.selectAll("g.bundle").data(bundles, d => [d.spaceId, d.hubId]);
                d3gBundle.enter()
                    .append("g")
                    .classed("bundle", true)
                    .style("stroke", d => d.colour)
                ;
                d3gBundle.each(function (dBundle) {
                    // Calculate the control points
                    let posMidRoot = dBundle.posRoots.reduce(
                        (p, c) => [p[0] + c[0], p[1] + c[1]],
                        [0, 0]
                    ).map(d => d / dBundle.posRoots.length);
                    if (isNaN(posMidRoot[0]) || isNaN(posMidRoot[1])) {
                        posMidRoot = dBundle.posHub;
                    }
                    let posControlMid = [
                        (posMidRoot[0] + dBundle.posHub[0] * 3) * 0.25,
                        (posMidRoot[1] + dBundle.posHub[1] * 3) * 0.25
                    ];
                    let posControlRoot = [
                        (posControlMid[0] + posMidRoot[0]) * 0.5,
                        (posControlMid[1] + posMidRoot[1]) * 0.5
                    ];
                    let posControlSelection = [
                        (posControlMid[0] + dBundle.posHub[0]) * 0.5,
                        (posControlMid[1] + dBundle.posHub[1]) * 0.5
                    ];

                    // Draw quadratic beziers from hub to root nodes
                    let d3gPathsRoot = d3.select(this).selectAll("path.root").data(dBundle.posRoots);
                    d3gPathsRoot.enter().append("path").classed("root", true);
                    d3gPathsRoot
                        // .transition()    //TODO: Make this work smoother -
                        // maybe not when moving, but okay for lower frequency updates, like edge option change
                        // move updates also don't need to recalculate some things
                        .attr("d", d => `M${posControlMid[0]},${posControlMid[1]} Q${posControlRoot[0]},${posControlRoot[1]} ${d[0]},${d[1]}`)
                    ;
                    d3gPathsRoot.exit().remove();

                    // Draw quadratic beziers from hub to selection nodes
                    let d3gPathsSelection = d3.select(this).selectAll("path.selection").data(
                        dBundle.posRelated
                    );
                    d3gPathsSelection.enter()
                        .append("path")
                        .classed("selection", true)
                    ;
                    d3gPathsSelection
                        // .transition()    //TODO: Make this work smoother -
                        // maybe not when moving, but okay for lower frequency updates, like edge option change
                        // move updates also don't need to recalculate some things
                        .attr("d", d => `M${posControlMid[0]},${posControlMid[1]} Q${posControlSelection[0]},${posControlSelection[1]} ${d[0]},${d[1]}`)
                    ;
                    d3gPathsSelection.exit().remove();
                });
                d3gBundle.exit().remove();
            }

            if (doMeta) {
                // The meta spaces have edges drawn between them, with edge counts
                let positions = {};
                d3divMetaspaces.selectAll("div.metanode").each(function(d) {
                    let pos = $(this).offset();
                    positions[d.name] = {
                        x: pos.left + $(this).width() / 2,
                        y: pos.top + $(this).height() / 2
                    };
                });

                let edges = _(model.nodes).chain()
                    .map((d) => d.paths)
                    .flatten(true)
                    .map((d) => [d[0], d[1]].sort())
                    .uniq(false, (d) => d[0] + " " + d[1])
                    .value()
                ;
                let d3edges = d3svgOverlay.selectAll("g.meta").data(edges);
                d3edges.enter()
                    .append("g")
                    .classed("meta", true)
                    .append("line")
                ;
                d3edges.select("line")
                    .attr("x1", (d) => positions[d[0]].x)
                    .attr("y1", (d) => positions[d[0]].y)
                    .attr("x2", (d) => positions[d[1]].x)
                    .attr("y2", (d) => positions[d[1]].y)
                ;
            }
        }
    }
}

